import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-32 pb-20 px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <div className="inline-flex items-center px-4 py-2 rounded-full border border-blue-600 bg-blue-50 mb-6">
              <span className="text-sm font-medium text-blue-600">Informations légales</span>
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Conditions générales
            </h1>
            <p className="text-lg text-gray-600">
              Dernière mise à jour : 2025
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Informations sur l'entreprise
              </h2>
              <div className="space-y-2 text-base text-gray-700">
                <p><strong>Entreprise :</strong> Rafal Szelenc IT Services</p>
                <p><strong>Propriétaire :</strong> Rafal Jozef Szelenc</p>
                <p><strong>SIRET :</strong> 102 261 021 00012</p>
                <p><strong>Adresse :</strong> 73 Rue Fieux, 31100 Toulouse, France</p>
                <p><strong>Téléphone :</strong> +33 6 05 98 52 60</p>
                <p><strong>Email :</strong> rafalszelenc@inbox.eu</p>
              </div>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                1. Objet
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Les présentes conditions générales régissent l'utilisation du site internet de Rafal Szelenc IT Services.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                Le site présente les services informatiques et de programmation proposés par l'entreprise, notamment le développement de logiciels sur mesure, l'installation et la configuration de serveurs, ainsi que la maintenance et le support informatique.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                2. Accès au site
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                L'accès au site est gratuit et ouvert à tous les utilisateurs disposant d'une connexion internet.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                Rafal Szelenc IT Services se réserve le droit de modifier, suspendre ou interrompre l'accès au site à tout moment, sans préavis, pour des raisons de maintenance ou d'amélioration.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                3. Propriété intellectuelle
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Tous les contenus du site (textes, images, éléments graphiques, logos, vidéos) sont protégés par les lois relatives à la propriété intellectuelle.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                Toute reproduction, distribution, modification ou utilisation des contenus du site sans autorisation préalable écrite de Rafal Szelenc IT Services est strictement interdite.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                4. Responsabilité
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Rafal Szelenc IT Services s'efforce de fournir des informations exactes et à jour sur le site. Toutefois, l'entreprise ne peut garantir l'exactitude, la complétude ou l'actualité des informations présentées.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                L'utilisateur reconnaît utiliser le site à ses propres risques. Rafal Szelenc IT Services ne pourra être tenu responsable des dommages directs ou indirects résultant de l'utilisation du site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                5. Liens externes
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Le site peut contenir des liens vers des sites externes. Rafal Szelenc IT Services n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leur disponibilité.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                6. Données personnelles
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Les informations concernant la collecte et le traitement des données personnelles sont détaillées dans notre Politique de confidentialité.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                7. Modification des conditions
              </h2>
              <p className="text-base text-gray-700 leading-relaxed">
                Rafal Szelenc IT Services se réserve le droit de modifier les présentes conditions générales à tout moment. Les modifications entrent en vigueur dès leur publication sur le site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                8. Droit applicable
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Les présentes conditions générales sont soumises au droit français.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                9. Contact
              </h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                Pour toute question concernant les présentes conditions générales, vous pouvez nous contacter :
              </p>
              <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                <p className="text-base text-gray-700 mb-2">
                  <strong>Email :</strong> <a href="mailto:rafalszelenc@inbox.eu" className="text-blue-600 hover:underline cursor-pointer">rafalszelenc@inbox.eu</a>
                </p>
                <p className="text-base text-gray-700 mb-2">
                  <strong>Téléphone :</strong> <a href="tel:+33605985260" className="text-blue-600 hover:underline cursor-pointer">+33 6 05 98 52 60</a>
                </p>
                <p className="text-base text-gray-700">
                  <strong>Adresse :</strong> 73 Rue Fieux, 31100 Toulouse, France
                </p>
              </div>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}